/*
  CUSTOM ADDITION — added 14.10.2026 by OH
  Purpose: Easter egg for the permanent badges on product cards (sold out, preorder, sale).
  On hover over a badge, its text runs through the badge like a ticker. On the first hover
  the badge text is turned into a marquee (two copies), the badge keeps its original width.
  When the hover ends, the current loop finishes and the text stops at its original
  position. Only on devices with hover (pointer: fine). Styling in assets/theme.css.
  A click on a badge opens the product, like a click on the image.
*/
(function () {
  var SELECTOR = '.product-card__badges-overlay .badge, .product-card .restock-rocket-preorder-badge';
  var SPEED = 40; // px per second
  var pointerQuery = window.matchMedia('(pointer: fine)');

  // Turns the badge text into a marquee on the first hover
  function build(badge) {
    var existing = badge.querySelector('.badge-marquee');
    if (existing) return existing;

    var text = badge.textContent.trim();
    if (!text) return null;

    // Measure the original text width, so the badge keeps its size
    var measure = document.createElement('span');
    measure.textContent = text;
    measure.style.whiteSpace = 'nowrap';
    badge.textContent = '';
    badge.appendChild(measure);
    var width = measure.getBoundingClientRect().width;

    var marquee = document.createElement('span');
    marquee.className = 'badge-marquee';
    marquee.style.width = width + 'px';

    var track = document.createElement('span');
    track.className = 'badge-marquee__track';

    for (var i = 0; i < 2; i++) {
      var item = document.createElement('span');
      item.className = 'badge-marquee__item';
      item.textContent = text;
      if (i > 0) item.setAttribute('aria-hidden', 'true');
      track.appendChild(item);
    }

    marquee.appendChild(track);
    badge.replaceChild(marquee, measure);

    // Same speed for every badge, no matter how long its text is
    var loopWidth = track.firstChild.getBoundingClientRect().width;
    marquee.style.setProperty('--badge-marquee-duration', (loopWidth / SPEED) + 's');

    // Stop exactly at the end of a loop, i.e. at the original position
    track.addEventListener('animationiteration', function () {
      if (marquee.dataset.stopping === 'true') {
        marquee.classList.remove('is-running');
        delete marquee.dataset.stopping;
      }
    });

    return marquee;
  }

  document.addEventListener('mouseover', function (event) {
    if (!pointerQuery.matches) return;
    var badge = event.target.closest && event.target.closest(SELECTOR);
    if (!badge || badge.contains(event.relatedTarget)) return;

    var marquee = build(badge);
    if (!marquee) return;
    delete marquee.dataset.stopping;
    marquee.classList.add('is-running');
  });

  document.addEventListener('mouseout', function (event) {
    var badge = event.target.closest && event.target.closest(SELECTOR);
    if (!badge || badge.contains(event.relatedTarget)) return;

    var marquee = badge.querySelector('.badge-marquee.is-running');
    if (marquee) marquee.dataset.stopping = 'true';
  });

  // A click on a badge opens the product, like a click on the image
  document.addEventListener('click', function (event) {
    if (!pointerQuery.matches) return;
    var badge = event.target.closest && event.target.closest(SELECTOR);
    if (!badge || badge.closest('a')) return; // badge inside the link already works

    var card = badge.closest('.product-card');
    var link = card && card.querySelector('.product-card__media');
    if (link) link.click();
  });
})();